import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../store/modules/ModalActions';
import { Col } from '../Col';
import { GenericModal } from '../GenericModal';
import { Row } from '../Row';
import styles from './ProgressModal.scss';

const rootClassName = styles.rootClassName;
const rootElementId = 'confirm-modal';

class ProgressModal extends Component {
  toClose = () => {
    this.props.closeModal(this.props.modalKey);
  };

  getProgressBar = (percent) => {
    const newPercent = percent * 100;
    return (
      <div className={rootClassName + '-track-bar'}>
        <div
          className={rootClassName + '-progress-bar'}
          style={{ width: newPercent + '%' }}
        ></div>
        <div className={rootClassName + '-text-bar'}>
          {Math.round(newPercent)}%
        </div>
      </div>
    );
  };

  render() {
    return (
      <GenericModal
        id={rootElementId}
        DialogProps={{
          maxWidth: 'sm',
          disableBackdropClick: true,
          disableEscapeKeyDown: true,
        }}
        title={this.props.title}
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            {this.getProgressBar(this.props.percent || 0)}
          </Col>
        </Row>
      </GenericModal>
    );
  }
}

ProgressModal.propTypes = {
  title: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProgressModal);
